"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "shared-spinner" };
var _hoisted_2 = {
    xmlns: "http://www.w3.org/2000/svg",
    style: { "shape-rendering": "auto", "animation-play-state": "running", "animation-delay": "0s" },
    viewBox: "23 23 54 54",
    preserveAspectRatio: "xMidYMid"
};
var _hoisted_3 = ["fill"];
var _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-1.1458333333333333s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_5 = [
    _hoisted_4
];
var _hoisted_6 = ["fill"];
var _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-1.0416666666666665s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_8 = [
    _hoisted_7
];
var _hoisted_9 = ["fill"];
var _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.9374999999999999s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_11 = [
    _hoisted_10
];
var _hoisted_12 = ["fill"];
var _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.8333333333333333s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_14 = [
    _hoisted_13
];
var _hoisted_15 = ["fill"];
var _hoisted_16 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.7291666666666665s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_17 = [
    _hoisted_16
];
var _hoisted_18 = ["fill"];
var _hoisted_19 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.6249999999999999s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_20 = [
    _hoisted_19
];
var _hoisted_21 = ["fill"];
var _hoisted_22 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.5208333333333333s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_23 = [
    _hoisted_22
];
var _hoisted_24 = ["fill"];
var _hoisted_25 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.41666666666666663s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_26 = [
    _hoisted_25
];
var _hoisted_27 = ["fill"];
var _hoisted_28 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.31249999999999994s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_29 = [
    _hoisted_28
];
var _hoisted_30 = ["fill"];
var _hoisted_31 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.20833333333333331s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_32 = [
    _hoisted_31
];
var _hoisted_33 = ["fill"];
var _hoisted_34 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "-0.10416666666666666s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_35 = [
    _hoisted_34
];
var _hoisted_36 = ["fill"];
var _hoisted_37 = /*#__PURE__*/ (0, vue_2.createElementVNode)("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.25s",
    begin: "0s",
    repeatCount: "indefinite"
}, null, -1);
var _hoisted_38 = [
    _hoisted_37
];
var vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SharedSpinner',
    props: {
        darkSpinner: { type: Boolean }
    },
    setup: function (__props) {
        var props = __props;
        var color = (0, vue_3.computed)(function () { return (props.darkSpinner ? "#8C8C8E" : "#B7B7BA"); });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("svg", _hoisted_2, [
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" }
                    }, _hoisted_5, 8, _hoisted_3),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(30 50 50)"
                    }, _hoisted_8, 8, _hoisted_6),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(60 50 50)"
                    }, _hoisted_11, 8, _hoisted_9),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(90 50 50)"
                    }, _hoisted_14, 8, _hoisted_12),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(120 50 50)"
                    }, _hoisted_17, 8, _hoisted_15),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(150 50 50)"
                    }, _hoisted_20, 8, _hoisted_18),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(180 50 50)"
                    }, _hoisted_23, 8, _hoisted_21),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(210 50 50)"
                    }, _hoisted_26, 8, _hoisted_24),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(240 50 50)"
                    }, _hoisted_29, 8, _hoisted_27),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(270 50 50)"
                    }, _hoisted_32, 8, _hoisted_30),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(300 50 50)"
                    }, _hoisted_35, 8, _hoisted_33),
                    (0, vue_2.createElementVNode)("rect", {
                        x: "47.5",
                        y: "24.5",
                        rx: "2.5",
                        ry: "2.97",
                        width: "5",
                        height: "11",
                        fill: color.value,
                        style: { "animation-play-state": "running", "animation-delay": "0s" },
                        transform: "rotate(330 50 50)"
                    }, _hoisted_38, 8, _hoisted_36)
                ]))
            ]));
        };
    }
});
